import { useParams } from "react-router-dom";
import AppointmentDetails from "../../components/appointment-details";
import { format } from "date-fns";
import { useAppointmentById } from "../../lib/hooks/doctors/use-appointment-by-id";
import { Loader2 } from "lucide-react";

function Appointment() {
  const params = useParams();
  const appointmentId = Number(params.id);

  const { appointment, isLoading } = useAppointmentById(appointmentId);

 // console.log("API Response:", appointment);

  const appointmentDate = appointment?.appointmentDate;

  const dayOfWeek = appointmentDate
    ? format(new Date(appointmentDate), "EEEE")
    : "";

  const startTime = appointment?.startTime
    ? format(new Date(appointment?.startTime), "hh:mm a").toLowerCase()
    : "";
  const endTime = appointment?.endTime
    ? format(new Date(appointment?.endTime), "hh:mm a").toLowerCase()
    : "";

  const slotTiming = `${startTime} - ${endTime}`;

  if (isLoading)
    return (
      <div className="flex h-screen items-center justify-center">
        <Loader2 className="size-8 animate-spin text-primary" />
      </div>
    );

  return (
    <AppointmentDetails
      data={{ 
        dayOfWeek,
        slotDate: appointmentDate ? new Date(appointmentDate) : undefined,
        slotTiming,
        symptoms: appointment?.symptoms ?? [],
        patient: {
          name: appointment?.patientName ?? "",
        },
        bookingId: appointment?.bookingId,
      }}
      doctor={{
        fullName: appointment?.doctorName ?? "",
        subDistrictOrCity: appointment?.clinicAddress,
        clinicName: appointment?.clinicName,
        fee: appointment?.fee,
        profilePhoto: appointment?.profilePhoto,
        specialities: appointment?.specialities,
      }}
      branchDetails={appointment?.branchDetails ?? []}
    />
  );
}

export default Appointment;
